import React from "react";

import {
  Box,
  Button,
  Stack,
  Typography,
  useMediaQuery,
} from "@braintrust/braintrust-ui-components";
import { RouterLink } from "@js/components/link";
import { ModalInstance } from "@js/components/modal";

import styles from "./styles.module.scss";

type OfferRequiresAcceptModalContentProps = { jobId: number; offerId: number };

export const OfferRequiresAcceptModalContent = ({
  jobId,
  offerId,
}: OfferRequiresAcceptModalContentProps) => {
  const isMobile = useMediaQuery("sm");
  const offerLink = `/jobs/${jobId}/offers/${offerId}/`;
  return (
    <Box sx={{ p: { xs: 3, sm: 4 } }}>
      <Typography
        component="h4"
        variant={isMobile ? "paragraph" : "title"}
        size={isMobile ? "large" : "small"}
        fontWeight={400}
        sx={{ mb: 2 }}
      >
        Updated Offer Requires Your Approval
      </Typography>
      <Typography
        component="p"
        variant="paragraph"
        size={"medium"}
        sx={{ mb: 4 }}
      >
        Your contract for this job has been extended, but you haven’t accepted
        the updated terms yet. To continue invoicing on this job, please review
        and accept the updated offer.
      </Typography>
      <Stack
        direction="row"
        sx={{ justifyContent: "end", alignItems: "center", gap: 1 }}
      >
        <Button
          variant="secondary"
          onClick={() => closeOfferRequiresAcceptModal()}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          RouterLink={RouterLink}
          to={offerLink}
          onClick={() => closeOfferRequiresAcceptModal()}
        >
          Review & Accept Offer
        </Button>
      </Stack>
    </Box>
  );
};

const closeOfferRequiresAcceptModal = () => {
  ModalInstance.close();
};

export const openOfferRequiresAcceptModal = (
  arg: OfferRequiresAcceptModalContentProps,
) => {
  ModalInstance.open({
    keepOnBackdropClick: true,
    children: <OfferRequiresAcceptModalContent {...arg} />,
    className: styles.modal,
    closeButton: false,
    padding: false,
  });
};
